module.exports = __webpack_public_path__ + "img/nahlieli_no.7850d745.png";